import React from 'react'

export function ModalRoot() {
  return <div id="modal-root"></div>
}
